import React, { useState } from 'react'
import './styles.scss'
import { config } from './config'
const nf = new Intl.NumberFormat('de-CH')

interface Props {
  range: [number, number]
  unit?: string
  step?: number
  submit: (a: string) => void
  start?: number
  formatValue?: (v: number) => string | number
}

export const Slider = ({
  range,
  unit,
  step = 1,
  submit,
  start,
  formatValue
}: Props) => {
  if (start == null) start = range[0] + (range[1] - range[0]) / 2

  const [value, setValue] = useState<number>(start)
  const [formState, setFormState] = useState<'loaded' | 'send' | 'error'>(
    'loaded'
  )
  const getPercent = (val: number, ran: [number, number]) => {
    return ((val - ran[0]) * 100) / (ran[1] - ran[0])
  }

  const valueFormat =
    formatValue ||
    ((val: number) => {
      return (unit ? unit : '') + ("\u00A0") + (val > 9999 ? nf.format(val) : val)
    })

  const currentPercent = getPercent(value, range)
  return (
    <div className='Slider'>
      <form
        onSubmit={(e: React.FormEvent) => {
          e.preventDefault()
          if (!value && value !== 0) {
            setFormState('error')
            return
          }
          submit(value.toString())
        }}
      >
        <div className='wrapper'>
          <div className='outputwrapper'>
            <output
              className={
                currentPercent > 80
                  ? 'right'
                  : currentPercent < 20
                  ? 'left'
                  : ''
              }
              style={{
                left: currentPercent + '%'
              }}
            >
              {valueFormat(value)}
            </output>
          </div>
          <input
            type='range'
            min={range[0]}
            max={range[1]}
            value={value}
            step={step}
            onChange={e => {
              setValue(+e.target.value)
            }}
          />
          <label className='left'>{valueFormat(range[0])}</label>
          <label className='right'>{valueFormat(range[1])}</label>
        </div>
        <div className='actionrow'>
          <button type='submit'>Antworten</button>
        </div>
      </form>
    </div>
  )
}
